<template>
  <div class="article article--6">
    <div class="article__elements">
      <Cross class="mobile-hidden" img-width="4.7rem" bottom="26.9rem" right="5.4rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="27.5rem" left="26rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="5.4rem" bottom="4.8rem" left="35rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="25.1rem" right="9.4rem" color="orange" />
      <Gift3 class="mobile-hidden" img-width="7.5rem" bottom="4.2rem" right="12.5rem" />
      <Gift4 class="mobile-hidden" img-width="11.3rem" bottom="3.8rem" left="5rem" />
      <Tree2 class="mobile-hidden" img-width="9rem" top="14.9rem" left="8rem" />
      <Star2 class="mobile-hidden" img-width="3.7rem" bottom="3.1rem" right="31.3rem" />
    </div>

    <div class="article__img article__img--6">
      <img class="mobile-hidden" src="@/assets/img/article6.png" alt="">
      <img class="mobile-visible" src="@/assets/img/article6-mob.png" alt="">
    </div>

    <div class="article__content">
      <h2 class="mobile-hidden article__title">
        {{ 'Праздник для всех и от каждого' | typograf }}
      </h2>
      <h2 class="article__title article__title--mob">
        {{ 'Праздник для всех' | typograf }}
      </h2>
      <h2 class="article__title article__title--mob">
        {{ 'и от каждого' | typograf }}
      </h2>
      <p class="article__subtitle">
        {{ 'Каким Дедом Морозом или Снегурочкой ты можешь начать свой путь в волонтерстве?' | typograf }}
      </p>
      <p class="article__text">
        {{ 'Какими бы тяжелыми не были последние пару лет для всего мира, они проявили лучшие качества, свойственные человеку —сострадание, гуманизм и взаимопомощь. На волне пандемии институт волонтерства получил серьезную поддержку от всех слоев населения и во всех странах. Многие люди стали не просто сочувствовать издалека, но и участвовать в помощи нуждающимся.' | typograf }}
      </p>
      <p class="article__text">
        {{ 'При этом способов помощи много, а впереди праздники, в которые чудеса становятся еще более актуальными. Ведь какой праздник без чудес. Пройди тест на «Ленте.ру» и узнай, каким волонтером ты можешь стать.' | typograf }}
      </p>
      <div class="article__button-box">
        <a href="https://lenta.ru/articles/2021/12/20/volontrs/" target="_blank">
          <button @click="gtmSend" class="button button--orange">Пройти тест</button>
        </a>
      </div>

      <ArticleFooter />
    </div>

  </div>
</template>

<script>
  import './article.scss'
  import Cross from "../Elements/Cross";
  import Snowflake2 from "../Elements/Snowflake2";
  import Gift3 from "../Elements/Gift3";
  import Tree2 from "../Elements/Tree2";
  import Gift4 from "../Elements/Gift4";
  import Star2 from "../Elements/Star2";
  import ArticleFooter from "../ArticleFooter/ArticleFooter";
  export default {
    name: "Article6",
    components: {ArticleFooter, Star2, Gift4, Tree2, Gift3, Snowflake2, Cross},
    methods: {
      gtmSend() {
        window.gtag('event', 'click', {
          'event_category': 'ch6_link_lenta_ru',
          'event_label': 'chapter_6'
        });
        window.ym(86974684, 'reachGoal', 'ch6_link_lenta_ru/click/chapter_6');
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
